import { takeEvery, fork, select } from 'redux-saga/effects';

import { TRACK_WEATHER_EVENT } from "../constants/actionTypes";
import { trackEvent } from "../utils/analytics";
import { getQueryParamValue } from '../utils/queryParam';

export function* trackAnalyticsEvent(action) {
  const { field } = yield select();
  const clientId = getQueryParamValue('client-id');
  trackEvent(action.noun, action.verb, {
    classification: 'weather',
    field_id: field.id,
    namespace: 'fieldview.weather',
    preview_user_id: clientId,
    source: 'web',
    taxonomy_version: 'v1',
    ...action.params,
  });
}

export function* trackAnalyticsEventWatcher() {
  yield takeEvery(TRACK_WEATHER_EVENT, trackAnalyticsEvent);
}

export default function* rootSaga() {
  yield fork(trackAnalyticsEventWatcher);
}
